export interface TableHeaderCell {
  id: string;
  label?: string;
  alignRight?: boolean;
}

export type TableSortOrder = "asc" | "desc";

export const DEFAULT_ROWS_PER_PAGE = 10;
